<template>
	<div>
		<div class="supervisorRank">
			<div class="titleIcon marb25">
				<div class="inlin">
					<i :class="`iconfont ${icon} tableIcon`"></i>
					<span class="fz16">{{title}}</span>
				</div>
				<div class="exportTab marl20" v-if="hospitalResultParameter.type == 2">
					<div class="sliderScreeningR">
						<a href="javascript:;" @click="seachTab(2)" :class="tabTypeName==2?'active':''">审核医生</a>
						<a href="javascript:;" @click="seachTab(4)" :class="tabTypeName==4?'active':''">诊断医生</a>
					</div>
				</div>
			</div>
			<div class="mart25" v-if="tableFlag">
				<template>
					<el-row :gutter="12">
						<el-col :span='12' ref="nationwide">
							<div id='samplingPie'></div>
						</el-col>
						<el-col :span='12' class="postr">
							<div class="inlin marb18 pieTable">
								<span class="fz16">含{{classification}}的{{tableTitle}}</span>
							</div>
							<el-table class="qcTable qcHeight scrollbar pieTable"
								:data="list.slice((currentPage-1)*pagesize,currentPage*pagesize)"
								style="height: 297px !important;">
								<template slot="empty">
									<div class="echartsNull">
										<div>
											<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
										</div>
										<div class="text">暂无数据</div>
									</div>
								</template>
								<el-table-column prop="DoctorName" label="姓名"></el-table-column>
								<el-table-column prop="Count" label="数量"></el-table-column>
								<el-table-column prop="Percent" label="数量占比">
									<template slot-scope="scope" slot="header">
										<el-tooltip class="item" effect="dark" content="数量占比 = 当前人员的分数数量/当前分数总数"
											placement="bottom">
											<span>
												数量占比 <i class="el-icon-info" style="color: #248AFD;"></i>
											</span>
										</el-tooltip>
									</template>
									<template slot-scope="scope">
										{{scope.row.Percent }}
									</template>
								</el-table-column>
								<el-table-column prop="" label="操作">
									<template slot-scope="scope">
										<span class="tableOpe"
											@click="qualifiedClick(scope.row,'qualified')">查看报告</span>
									</template>
								</el-table-column>
							</el-table>
							<div class="pages">
								<el-pagination class="pageAll" align="center" layout="prev, pager, next"
									:total="list.length" :page-size='pagesize' :current-page='currentPage'
									@current-change='currentChange'>
								</el-pagination>
							</div>
						</el-col>
					</el-row>
				</template>
			</div>
			<div class="echartsNull" v-else>
				<div class="position">
					<div class="marb18">
						<i class="iconfont icona-icon_default_Notsampled"></i>
					</div>
					<div class="text">该时间段未对{{tableTitle}}进行抽样</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		props: ['scoreAreaList', 'icon', 'title', 'tabType'],
		data() {
			return {
				pagesize: 5,
				total: 0,
				currentPage: 1,
				tabTypeName: 2,
				list: [],
				scoreType: 1,
				tableTitle: '审核医生',
				classification: '<60',
				paramsindex: ''
			}
		},
		computed: {
			...Vuex.mapState('centralStatistics', ['trigger', 'hospitalResultParameter', 'tableFlag', 'reportDate']),
			...Vuex.mapState('supervisor', ['HospitalAVGScoreArr', 'QualifiedPart', 'breadcrumbList', 'GetReportListArr']),
			...Vuex.mapState('breadcrumb', ['skinPeeler']),
			triggers() {
				return this.trigger.flag;
			}
		},
		watch: {
			skinPeeler: {
				handler(newValue, oldValue) {
					if (this.tableFlag) {
						this.getEchartsPie(this.scoreAreaList);
					}
				},
				deep: true
			},
			hospitalResultParameter: {
				handler(newValue, oldValue) {
					if (this.hospitalResultParameter.type != 2) {
						this.tableTitle = '技师'
					} else {
						this.tableTitle = this.tabTypeName == 2 ? '审核医生' : '诊断医生';
					}
				},
				deep: true
			},
			triggers(old) {
				this.$nextTick(() => {
					if (old && this.tableFlag) {
						this.trigger.flag = false;
						this.getEchartsPie(this.scoreAreaList);
					}
				})
			},
			scoreAreaList: {
				handler(old) {
					let _this = this;
					this.$nextTick(() => {
						if (_this.tableFlag) {
							_this.getEchartsPie(_this.scoreAreaList);
						}
					})
				},
				deep: true
			}
		},
		activated() {
			//左侧导航收起时右侧图联动
			let _this = this;
			this.paramsindex = '';
			if (this.tabType) {
				this.tabTypeName = 2;
			}
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (_this.myChart) {
					let dom = document.getElementById('samplingPie');
					if (dom) {
						dom.style.width = _this.$refs.nationwide.$el.offsetWidth - 140 + "px";
						_this.myChart.resize();
						_this.getEchartsPie(_this.scoreAreaList);
					}
				}
			})
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'settableLoading', 'setLoading',
				'setBreadcrumbList'
			]),
			...Vuex.mapActions('centralStatistics', ['GetScoreArea']),
			currentChange(val) {
				this.currentPage = val;
			},
			qualifiedClick(row, type) {
				this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.HospitalAVGScoreArr.type = this.hospitalResultParameter.type == 1 ? 3 : this.tabTypeName;
				this.QualifiedPart.hospitalGuid = this.hospitalResultParameter.hospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = type;
				this.QualifiedPart.scoreType = this.scoreType;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.breadcrumbList.push(this.reportDate.data[0] + '-' + this.reportDate.data[1]);
				this.breadcrumbList.push(row.DoctorName);
				this.$router.push("/home/supervisor/qualifiedTable");
				this.breadcrumbList.push("scoreType");
			},
			seachTab(type) {
				let _this = this;
				this.tabTypeName = type;
				this.tableTitle = type == 2 ? '审核医生' : '诊断医生';
				this.GetScoreArea({
					doctorType: type
				}).then(res => {
					_this.getEchartsPie(_this.scoreAreaList);
				});
			},
			getEchartsPie(data) {
				if (document.getElementById('samplingPie')) {
					document.getElementById('samplingPie').removeAttribute('_echarts_instance_');
				}
				let dom = document.getElementById('samplingPie'),
					_this = this,
					app = {},
					option = null,
					datas = [],
					color = [],
					total = 0,
					index = null;
				if (dom) {
					this.myChart = echarts.init(dom);
				}
				let changeColor = this.skinPeeler.status ? '#ffffff' : '#333333';
				color = ['#34D1BF', '#248AFD', '#FF721B'];
				data.map((item, index) => {
					total += Number(item.ReportCount);
					datas.push({
						name: item.Desc,
						value: item.ReportCount,
						Percent: item.Percent,
						Doctors: item.Doctors
					})
				})
				if (this.paramsindex == '') {
					for (let i = 0; i < data.length; i++) {
						if (data[i].ReportCount != 0) {
							index = i;
							break;
						}
					}
				} else {
					index = this.paramsindex;
				}
				this.classification = datas[index].name;
				this.list = datas[index].Doctors;
				this.scoreType = index + 1;
				option = {
					color: color,
					legend: {
						icon: 'circle',
						orient: 'vertical',
						right: 0,
						y: 'center',
						textStyle: {
							color: changeColor,
							rich: {
								a: {
									fontSize: 12,
								},
							}
						},
						data: datas,
						formatter: function(name) {
							let target;
							let Percent;
							for (let i = 0, l = datas.length; i < l; i++) {
								if (datas[i].name == name) {
									target = datas[i].value;
									Percent = datas[i].Percent;
								}
							}
							if (name.length == 3) {
								name = name + '          '
							} else if (name.length == 4) {
								name = name + '        '
							}
							let arr = [
								'{a|' + name + '抽样报告' + target + '份占比' + Percent + '}',
							]
							return arr.join('\n')
						}
					},
					tooltip: {
						trigger: 'item',
						confine: true,
						formatter: function(params) {
							let relVal = params.seriesName;
							relVal += '<br/>' + params.marker + params.name + ' : ' + params.value + '份'
							return relVal
						}
					},
					series: [{
						// hoverAnimation:false,
						name: '质控数',
						type: 'pie',
						center: ['40%', '50%'],
						radius: ['55%', '65%'],
						label: {
							show: false,
							color: changeColor,
							formatter: '{b|{b}}',
							alignTo: 'labelLine',
							rich: {
								b: {
									align: 'left',
									color: changeColor
								}
							},
							normal: {
								show: false
							}
						},
						label: {
							normal: {
								show: true,
								position: 'center',
								color: '#4c4a4a',
								formatter: '{total|' + total + '}' + '{active|份}' + '\n\r\n\r' +
									'{active|抽样报告}',
								rich: {
									total: {
										fontSize: 52,
										color: '#248AFD'
									},
									active: {
										fontSize: 20,
										color: changeColor,
										lineHeight: 30,
									},
								}
							},
							emphasis: { //中间文字显示
								show: true,
							},
						},
						labelLine: {
							lineStyle: {
								color: changeColor
							},
							length2: 3
						},
						data: datas
					}]
				};
				if (this.myChart && option && typeof option === "object") {
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.paramsindex = params.dataIndex;
						this.classification = params.name;
						this.scoreType = this.paramsindex + 1;
						this.myChart.dispatchAction({
							type: "highlight",
							seriesIndex: this.paramsindex,
							dataIndex: this.paramsindex
						});
						this.list = [];
						this.list = params.data.Doctors;
					});

					this.myChart.dispatchAction({
						type: "highlight",
						seriesIndex: 0,
						dataIndex: index
					});
					this.myChart.on("mouseover", function(e) {
						if (e.dataIndex != index) {
							_this.myChart.dispatchAction({
								type: "downplay",
								seriesIndex: 0,
								dataIndex: index
							});
						}
					});
					this.myChart.on("mouseout", function(e) {
						index = e.dataIndex;
						_this.myChart.dispatchAction({
							type: "highlight",
							seriesIndex: 0,
							dataIndex: index
						});
					});
				}
				window.addEventListener("resize", () => {
					_this.myChart.resize();
				});
			}
		},
	}
</script>
<style type="text/css">
	.bigScreen .supervisorPages .supervisorRank {
		padding-left: 20px;
		padding-right: 20px;
	}

	.doctorPage .pages {
		margin: 20px 0 0;
	}

	#samplingPie {
		width: 100%;
		height: 336px;
		margin: 0 auto;
	}

	.qcTable {
		background-color: #292b31 !important;
	}

	.pieTable {
		padding: 0 20px;
	}
</style>
<style type="text/css" scoped="scoped">
	.position {
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}

	.echartsNull {
		height: 335px;
	}
</style>
